import {AuthenticationAction, AuthenticationPayload, AuthError} from './auth.service';
import {defer, first, Observable} from 'rxjs';
import {catchError} from 'rxjs/operators';
import {AuthenticationTokens} from '../model';
import {Application, UserAuthenticationService} from './user-authentication.service';

export interface UserCredentials extends AuthenticationPayload {
  email: string,
  password: string;
}

export interface MCardsTemporaryAuthenticationToken extends AuthenticationPayload {
  token: string,
  application: Application
}

export class UserCredentialsLoginAction implements AuthenticationAction {

  constructor(private userService: UserAuthenticationService, private userCredentials: UserCredentials) {
  }

  login(): Observable<AuthenticationTokens> {
    return defer(() => this.userService.loginWithCredentials(this.userCredentials.email, this.userCredentials.password))
      .pipe(
        first(),
        catchError(error => {
          switch (error.code) {
            case "auth/invalid-email":
            case "auth/wrong-password":
            case "auth/user-not-found":
            case "auth/user-disabled":
              throw AuthError.INVALID_CREDENTIALS;
          }
          throw AuthError.UNKNOWN;
        })
      );
  }

}

export class MCardsTokenAuthenticationAction implements AuthenticationAction {

  constructor(private userService: UserAuthenticationService, private authenticationToken: MCardsTemporaryAuthenticationToken) {
  }

  login(): Observable<AuthenticationTokens> {
    return defer(() => this.userService.loginWithMcardsTokenToken(this.authenticationToken.token,
      this.authenticationToken.application))
      .pipe(
        first(),
        catchError(error => {
          //TODO once mCards authentication is clarified we should handle error states.
          throw AuthError.UNKNOWN;
        })
      );
  }
}
